import { useEffect } from 'react';
import { getCookies } from '../api/api';
import { useAppStore } from '../store/AppContext';
import { useAuthStore } from '../store/AuthContext';
import { SessionChecker } from '../utils/SessionChecker';

function useSessionChecking(
  view: string,
  setGoOn: (goOn: boolean) => void,
  goOn?: boolean,
) {
  const dataApp = useAppStore();
  const dataUser = useAuthStore();

  useEffect(() => {
    async function doCheck() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const response = await SessionChecker.checkSession(
        view,
        dataApp.lang,
        dataUser.user.isApp === 'true',
        dataUser.user.isRecuerdame,
      );
      setGoOn(response);
    }

    if (!goOn) {
      const token = getCookies().get('token');
      if (token) {
        dataApp.loadHeader(dataApp.lang);
      }
      doCheck();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser]);
}
export default useSessionChecking;
